import useDateRange from "helpers/hooks/useDateRange"

import AlertsContainer from "widgets/alerts/AlertContainer"
import { BodyContainer } from "widgets/styled/containers"

function ActivityTab() {
  const { getDateRangeTools } = useDateRange()
  const {
    dateRange: eventsDateRange,
    dispatchDateRange: dispatchEventsDateRange,
    isDateRangeValid: isEventsDateRangeValid,
  } = getDateRangeTools("events")
  return (
    <BodyContainer disableGutters maxWidth="xl">
      <AlertsContainer
        dateRange={eventsDateRange}
        dispatchDateRange={dispatchEventsDateRange}
        isDateRangeValid={isEventsDateRangeValid}
      />
    </BodyContainer>
  )
}

export default ActivityTab
